module.exports = new __parcel__URL__("farground_cloud_1.97eb9072.png").toString();